<template>
  <a-row :gutter="8">
    <a-col :span="8">
      <div class="container">
        <div class="total">
          <span class="total-label">客户总数</span>
          <span class="total-number" :style="{fontSize: `${totalNumberSize}px`}">{{ formatThousandSeparator((keyData.customerTotal ?? 0).toString()) }}</span>
        </div>
        <div class="bars">
          <template v-for="(item, index) in keyData.totalData" :key="index">
            <div class="bar">
              <div class="leftTag" :style="{ backgroundColor: item.color, width: '10px' }"></div>
              <p class="label">{{ item.desc }}</p>
              <div class="progress" :style="{ backgroundColor: item.color, width: item.width }"></div>
              <p class="value">{{ formatThousandSeparator(item.value.toString()??'')}}</p>
            </div>
          </template>
        </div>
      </div>
    </a-col>
    <a-col :span="8">
      <div class="container">
        <div class="total">
          <span class="total-label">客户跟进及时率</span>
          <span class="total-number" :style="{fontSize: `${totalNumberSize}px`}">{{ keyData.customerFollowingUpRate??'0%' }}</span>
        </div>
        <div class="bars">
          <template v-for="(item, index) in keyData.followRate" :key="index">
            <div class="bar">
              <div class="leftTag" :style="{ backgroundColor: item.color, width: '10px' }"></div>
              <span class="label">{{ item.desc }}</span>
              <div class="progress" :style="{ backgroundColor: item.color, width: item.width  }"></div>
              <p class="value">{{ item.value }}</p>
            </div>
          </template>
        </div>
      </div>
    </a-col>
    <a-col :span="4">
      <div class="rightContainer">
        <div class="rightTotal">
          <span class="total-label">客户上门拜访完成率</span>
          <span class="total-number center-rate" :style="{fontSize: `${totalNumberSize}px`}">{{ keyData.visitCompletedRate }}</span>
        </div>
      </div>
    </a-col>
    <a-col :span="4">
      <div class="rightContainer">
        <div class="rightTotal">
          <span class="total-label">异动反馈率</span>
          <span class="total-number center-rate" :style="{fontSize: `${totalNumberSize}px`}">{{ keyData.alarmFeedbackRate }}</span>
        </div>
      </div>
    </a-col>
  </a-row>
</template>
<script lang="ts" setup>
import { onMounted, onUnmounted, PropType, ref, watch } from 'vue'
import formatThousandSeparator from '@/utils/format'
import { getCustomerKeyDataBoard } from '@/api/gucangSales/dataBoard'
const props = defineProps({
  formState: {
    type: Object as PropType<Object>
  }
})
const keyData = ref<any>({})
const totalNumberSize = ref(32)
onMounted(() => {
  totalNumberSize.value = (32 * window.innerWidth / 1920) < 20 ? 20 : (Math.ceil(32 * window.innerWidth / 1920))
  window.addEventListener('resize', handleResize)
  getCustomerDashData()
})
onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
const handleResize = () => {
  totalNumberSize.value = (32 * window.innerWidth / 1920) < 20 ? 20 : (Math.ceil(32 * window.innerWidth / 1920))
}
watch(() => props.formState, (val) => {
  getCustomerDashData()
})
const getCustomerDashData = () => {
  getCustomerKeyDataBoard(props.formState)
    .then((res:any) => {
      keyData.value.customerTotal = res.data.customerTotal ?? 0
      keyData.value.customerFollowingUpRate = res.data.customerFollowingUpRate ?? '0%'
      keyData.value.visitCompletedRate = res.data.visitCompletedRate ?? '0%'
      keyData.value.alarmFeedbackRate = res.data.alarmFeedbackRate ?? '0%'
      keyData.value.totalData = [
        {
          desc: '潜在',
          value: res.data.potentialTotal ?? 0,
          color: '#FF9A3E',
          width: '0%'
        },
        {
          desc: '签约',
          value: res.data.contractTotal ?? 0,
          color: '#1CA550',
          width: '0%'
        },
        {
          desc: '成交',
          value: res.data.transactionTotal ?? 0,
          color: '#1D4CD2',
          width: '0%'
        }
      ]
      keyData.value.followRate = [
        {
          desc: '潜在',
          value: res.data.potentialFollowingUpRate ?? '0%',
          color: '#FF9A3E'
        },
        {
          desc: '签约',
          value: res.data.contractFollowingUpRate ?? '0%',
          color: '#1CA550'
        },
        {
          desc: '成交',
          value: res.data.transactionFollowingUpRate ?? '0%',
          color: '#1D4CD2'
        }
      ]
      animateBars()
    })
}
const animateBars = () => {
  const number = keyData.value.totalData.map((item: any) => {
    return item.value
  })
  const max = Math.max(...number)
  keyData.value.totalData.forEach((bar: any, index: number) => {
    setTimeout(() => {
      const percent = bar.value / max
      bar.width = `${percent * 100}%`
    }, 300)// Delay each bar's animation by 300ms
  })
  keyData.value.followRate.forEach((bar: any, index: number) => {
    setTimeout(() => {
      bar.width = bar.value
    }, 300)// Delay each bar's animation by 300ms
  })
}
</script>
<script lang="ts">
export default {
  name: 'CustomerKeyData'
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 60px 20px 20px;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  margin-bottom: 8px;
  height: 140px;
}
.total {
  font-size: 20px;
  width: 30%;
  margin-bottom: 20px;
}
.rightContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 20px 20px 20px;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  margin-bottom: 8px;
  height: 140px;
}
.rightTotal {
  font-size: 20px;
  width: 100%;
  margin-bottom: 20px;
}
.total-label {
  font-size: 14px;
  color: #5B687D;
}

.total-number {
  font-family: Lato,sans-serif;
  display: block;
  font-size: 32px;
  color: #26292E;
  letter-spacing: 1px;
  margin-top: 10px;
  word-wrap: break-word;
  font-weight: 800;
  line-height: 36px;
  text-align: left;
}
.total-number.center-rate {
  text-align: center;
}
.bars {
  width: 70%;
}

.bar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.label {
  width:60px;
  flex-shrink: 0;
  text-align: left;
  font-size: 14px;
}

.leftTag {
  height: 2px;
  flex-shrink: 0;
  margin-right: 5px;
}

.progress {
  height: 18px;
  left: 10px;
  margin-left: 10px;
  margin-right: 10px;
  transition: width 1s ease-in-out; /* Animation for width */
}

.value {
  font-size: 14px;
}
</style>
